<footer>
    <div class="container d-flex flex-wrap justify-content-between align-items-start">
        <img src="assets/img/logo/logotipo_uoh-white.svg" alt="Logo Universidad de O'Higgins" class="img-fluid logo">

        <div class="text-light mt-4 mt-md-0">
            <strong>CONTACTO</strong>
            <p>Avenida Libertador Bernardo O'Higgins 611, Rancagua.</p>
            <p>Tel: <a href="tel:+56229030000" class="link-light link-underline-opacity-0">(56) 22903 0000</a></p>
        </div>
    </div>
</footer>
